import React from 'react';
import { Segment, Button, Divider, Icon, Form, Grid, Input, } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import FilterStudent from './FilterStudent';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class ConnectStudentWithNewStudyProgram extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            oldStudyProgram: null,
            newStudyProgram: null,
            studentsBySPB: [],
            disableButton: false,
            back: false,
            student: JSON.parse(localStorage.getItem('student')),
            filterDataList: JSON.parse(localStorage.getItem('filterDataList')),
            studentsInfo: JSON.parse(localStorage.getItem('studentsInfo')),
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeForm = this.closeForm.bind(this);
        this.connectStudents = this.connectStudents.bind(this);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    closeForm() {
        this.setState({
            oldStudyProgram: null,
            newStudyProgram: null,
        });
    }


    connectStudents() {
        if (!this.state.newStudyProgram) {
            toast('Niste unijeli sve podatke.');
            if (!this.state.newStudyProgram) { this.setState({ newStudyProgramErr: true }); } else { this.setState({ newStudyProgramErr: false }); }
        } else {
            localStorage.setItem('index', this.state.student.index);

            let obj = {
                id: this.state.student.id,
                studyProgramId: this.state.newStudyProgram.el.studyProgramId,
            };
            axios.put('/students/switch-to-new-study-program/', { ...obj })
                .then(res => {
                    this.setState({
                        loader: false,
                    });
                    localStorage.setItem('student', JSON.stringify(res.data));
                }).then(() => {
                    this.setState({ show: true });
                    toast('Student je uspješno povezan.');
                })
                .catch(err => {
                    this.setState({ loader: false });
                    if (err.response.data === 'This student has already changed study program.') {
                        toast('Student je već prebačen na novi studijski program!');
                    }
                    if (err.response.data === 'Students cannot switch to the same study program they are already enrolled in!') {
                        toast('Student se ne može prebaciti na studijski program na koji je već upisan.');
                    } else {
                        toast('Student nije prebačen na novi studijski program.');
                    }
                });
        }
    }

    render() {
        let candidateDisplayName = this.state.student.firstName + ' ' + this.state.student.lastName + '    ' + this.state.student.studyProgramName;

        if (this.state.show) {
            return <Redirect push to={{ pathname: '/prelazak-studenata/priznavanje-ispita' }} />;
        }
        if (this.state.back === true) {
            return (<FilterStudent></FilterStudent>);
        }
        return (
            <div>
                <Segment.Group raised>
                    <Segment>
                        <h3>Prelazak studenata sa jednog na drugi nastavni plan i program</h3>
                    </Segment>
                    <Segment clearing>
                        <Grid columns={2}>
                            <Divider vertical>
                                <Icon name="exchange" />
                            </Divider>

                            <Grid.Column>
                                <Form>
                                    <Segment>
                                        <Form.Group widths="equal">

                                            <Form.Field required>
                                                <label>
                                                    Student na trenutnom nastavnom planu i programu
                                                </label>
                                                <input
                                                    required
                                                    fluid
                                                    disabled
                                                    placeholder="Ime i prezime studenta, index, studijski program"
                                                    control={Input}
                                                    name="oldStudyProgram"
                                                    value={candidateDisplayName}
                                                />
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>
                                </Form>
                            </Grid.Column>

                            <Grid.Column>
                                <Form>
                                    <Segment>
                                        <Form.Group widths="equal">
                                            <Form.Field required error={this.state.newStudyProgramErr}>
                                                <label>
                                                    Student na novom nastavnom planu i programu
                                                </label>
                                                <Form.Dropdown
                                                    placeholder="Ime i prezime studenta, index, studijski program"
                                                    search
                                                    fluid
                                                    selection
                                                    options={this.state.filterDataList.filter(e => e.studentId === this.state.student.studentId && e.id !== this.state.student.id)}
                                                    onChange={this.handleInputChange}
                                                    value={this.state.newStudyProgram}
                                                    name="newStudyProgram"
                                                    clearable

                                                />
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>
                                </Form>

                            </Grid.Column>

                        </Grid>
                    </Segment>

                    <Segment clearing>
                        <Button basic color="blue" floated="right" onClick={() => { this.setState({ back: true }); }}>Odustani</Button>
                        <Button
                            primary
                            color="blue"
                            floated="right"
                            onClick={this.connectStudents}
                        >Potvrdi</Button>
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamRecognition/ConnectStudentWithNewStudyProgram.js